import React from 'react';

const QuantitativePhase = ({ onNext, onChange, t }) => {
  return (
    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">{t.title}</h2>
      <ul className="space-y-4">
        {t.questions.map((item, index) => (
          <li key={index}>
            <label className="block">
              <div className="flex items-center space-x-4">
                <input
                  type="checkbox"
                  className="form-checkbox h-6 w-6 text-indigo-600"
                  onChange={() => onChange(item.question)}
                />
                <span className="text-gray-800 font-medium">{item.question}</span>
              </div>
              <p className="text-gray-600 text-sm mt-1 ml-10">{item.example}</p>
            </label>
          </li>
        ))}
      </ul>
      <button
        onClick={onNext}
        className="mt-6 w-full font-bold bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-500"
      >
        {t.button}
      </button>
    </div>
  );
};

export default QuantitativePhase;
